import React from "react";
import { Routes, Route } from "react-router-dom";
import InviteRedirect from "../InviteRedirect";
import NotFound from "../NotFound";

export default function InviteRouter() {
  return (
    <Routes>
      <Route path="invite/:inviteCode" element={<InviteRedirect />} />
      <Route path=":inviteCode" element={<InviteRedirect />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
